import { SurveyQuestionEnum } from './../../../../models/graphqlTypes'
import isEmpty from 'lodash/isEmpty'
import omit from 'lodash/omit'
import { InputSurveyQuestionAnswer } from '../../../../models/graphqlTypes'
import {
  Survey,
  SurveyQuestionAnswer,
  SurveySchemaQuestion,
} from '../../../doctor/SurveyStore/types/surveyStore.types'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const omitTypeName = (answer: any) => {
  const withoutTypeName = omit(answer, '__typename')
  return isEmpty(withoutTypeName) ? null : withoutTypeName
}

const getInitialAnswerForQuestion = (
  survey: Survey,
  question: SurveySchemaQuestion,
  answers: SurveyQuestionAnswer[]
): InputSurveyQuestionAnswer => {
  const savedAnswer = answers.find(
    (answer) => answer.surveyQuestionId === question.surveyQuestion.id
  )
  // TODO addTypename: false in ApolloProvider instead of omit
  const initialAnswers = savedAnswer
    ? {
        mcQuestionAnswer: omitTypeName(savedAnswer.mcQuestionAnswer),
        scaleQuestionAnswer: !!savedAnswer.scaleQuestionAnswer
          ? {
              ...omitTypeName(savedAnswer.scaleQuestionAnswer),
              aspectAnswers:
                savedAnswer.scaleQuestionAnswer?.aspectAnswers?.map(
                  (aspectAnswer) => omit(aspectAnswer, '__typename')
                ) || null,
            }
          : null,

        simpleTextQuestionAnswer: omitTypeName(
          savedAnswer.simpleTextQuestionAnswer
        ),
        fileUploadQuestionAnswer: !!savedAnswer.fileUploadQuestionAnswer
          ?.documents
          ? {
              documents: savedAnswer.fileUploadQuestionAnswer.documents.map(
                (doc) => omit(doc, '__typename') || null
              ),
            }
          : null,
      }
    : {
        mcQuestionAnswer: null,
        scaleQuestionAnswer: null,
        simpleTextQuestionAnswer: null,
        fileUploadQuestionAnswer: null,
      }

  return {
    surveyId: survey.id,
    surveyQuestionId: question.surveyQuestion.id,
    ...initialAnswers,
  }
}

export const getInitialAnswers = (
  survey: Survey
): InputSurveyQuestionAnswer[] => {
  return survey.surveySchema.surveySchemaQuestions.map(
    (question: SurveySchemaQuestion) =>
      getInitialAnswerForQuestion(
        survey,
        question,
        survey.surveyQuestionAnswers
      )
  )
}

export const getIsAnswerFilled = (
  answer: InputSurveyQuestionAnswer,
  type: SurveyQuestionEnum
): boolean => {
  switch (type) {
    case SurveyQuestionEnum.SimpleText:
      return !isEmpty(answer.simpleTextQuestionAnswer?.text)
    case SurveyQuestionEnum.MultipleChoice:
      return !!answer.mcQuestionAnswer?.selectedChoiceIds?.length
    case SurveyQuestionEnum.Scale:
      return !isEmpty(answer.scaleQuestionAnswer?.aspectAnswers)
    case SurveyQuestionEnum.FileUpload:
      return !isEmpty(answer.fileUploadQuestionAnswer?.documents)
    default:
      return true
  }
}

export const filterFilledAnswers = (
  answers: InputSurveyQuestionAnswer[],
  questions: SurveySchemaQuestion[]
): InputSurveyQuestionAnswer[] =>
  answers
    .filter((answer) => {
      const questionOfAnswer = questions.find(
        (question) => question.surveyQuestion.id === answer.surveyQuestionId
      )
      return getIsAnswerFilled(
        answer,
        questionOfAnswer?.surveyQuestion.type as SurveyQuestionEnum
      )
    })
    .map((answer) => {
      const questionOfAnswer = questions.find(
        (question) => question.surveyQuestion.id === answer.surveyQuestionId
      )
      if (questionOfAnswer?.surveyQuestion.type === SurveyQuestionEnum.Scale) {
        return {
          ...answer,
          scaleQuestionAnswer: {
            ...answer.scaleQuestionAnswer,
            aspectAnswers: answer.scaleQuestionAnswer?.aspectAnswers?.map(
              (aspectAnswer) =>
                isNaN(+aspectAnswer.aspectId)
                  ? aspectAnswer
                  : { ...aspectAnswer, aspectId: '' }
            ),
          },
        }
      }
      return answer
    })

export const getAreAllQuestionsNotRequired = (
  questions: SurveySchemaQuestion[]
): boolean =>
  questions.length === questions.filter((question) => !question.required).length
